import settingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";

const JURISDICTIONS = [Jurisdiction.UK, Jurisdiction.SE];

class G288SettingsModel {

    public needQuickerSpin() {
        return settingsModel.isJurisdiction(JURISDICTIONS);
    }

}

const g288SettingsModel = new G288SettingsModel();
export default g288SettingsModel;


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/model/g288-settings-model.ts